<style lang="scss">
.select-box {
    position: relative;
    background: #FFFFFF;
    border: 1px solid #e5e7e8;
    border-radius: 5px;
    font-size: 16px;
    line-height: 19px;
    color: #333;
    padding: 15px 12px;
    cursor: pointer;

    &.opened {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;

        .icon {
            transform: rotate(180deg);
        }
    }
}

.placeholder {
    color: #999999;
}

.icon {
    position: absolute;
    right: 12px;
    top: 21px;
    transition: transform 0.2s;
}

ul {
    display: block;
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    z-index: 10;
    top: 100%;
    width: 100%;
    border: 1px solid #e5e7e8;
    max-height: 205px;
    overflow: auto;
    left: -1px;
    background: inherit;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

li {
    padding: 4px 12px;
    cursor: pointer;

    &:hover,
    &.selected {
        background: #eef5f9;
    }
}
</style>
<script lang="ts" context="module">
type IDType = string | number;
export interface SelectItem {
    id: IDType;
    value: string;
}
</script>
<script lang="ts">
import { createEventDispatcher, tick } from 'svelte';

export let items: SelectItem[] = [];
export let selected: IDType | undefined = undefined;
export let placeholder = '';
let itemsContaner: HTMLElement;
let selectedItem: SelectItem | undefined;
let opened = false;
const dispatch = createEventDispatcher();

$: selectedItem = items.find(item => item.id === selected);

async function toggle() {
    opened = !opened;
    if (opened) {
        await tick();
        if (itemsContaner) {
            const selItem = itemsContaner.querySelector('.selected');
            if (selItem) {
                selItem.scrollIntoView();
            }
        }
    }
}

function setValue(nextValue: IDType | undefined) {
    if (selected !== nextValue) {
        selected = nextValue;
        dispatch('change', selected);
    }
}
</script>
<svelte:body on:click={() => opened = false} />
<div class="select-box" class:opened on:click|stopPropagation={toggle}>
    <svg class="icon" width="12" height="8" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C11.412 0 11.6472 0.470382 11.4 0.8L6.4 7.46667C6.2 7.73333 5.8 7.73333 5.6 7.46667L0.6 0.8C0.352787 0.470382 0.587977 0 1 0L11 0Z" fill="currentColor"/>
    </svg>

    <div class="cur-item" class:placeholder={!selectedItem}>
        {selectedItem ? selectedItem.value : placeholder}
    </div>
    {#if opened}
        <ul bind:this={itemsContaner}>
            {#each items as item}
                <li class:selected={selected === item.id} on:click={() => setValue(item.id)}>{item.value}</li>
            {/each}
        </ul>
    {/if}
</div>
